"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WickedApiClient_1 = require("../api/WickedApiClient");
var i0 = require("@angular/core");
var i1 = require("../api/WickedApiClient");
var CustomEmojiService = /** @class */ (function () {
    function CustomEmojiService(emojiClient) {
        this._emojis = null;
        this.emojiClient = emojiClient;
    }
    Object.defineProperty(CustomEmojiService.prototype, "emojis", {
        get: function () {
            var _this = this;
            var func = function (resolve, reject) {
                if (_this._emojis != null) {
                    resolve(_this._emojis);
                }
                else {
                    _this.emojiClient.getEmojis().subscribe(function (result) {
                        if (result.error && result.error != "") {
                            reject(result.error);
                        }
                        else {
                            _this._emojis = result.emojis;
                            resolve(result.emojis);
                        }
                    });
                }
            };
            return new Promise(func);
        },
        enumerable: true,
        configurable: true
    });
    CustomEmojiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomEmojiService_Factory() { return new CustomEmojiService(i0.ɵɵinject(i1.EmojiClient)); }, token: CustomEmojiService, providedIn: "root" });
    return CustomEmojiService;
}());
exports.CustomEmojiService = CustomEmojiService;
